<template>
    <div class="info-container">
        <div class="additional-info-wrapper">

            <div class="additional-info-label" style="margin-left: 32px;">عنوان</div>
            <div class="additional-info-item" @click="handleTitle()" style="position: relative">
                <span v-if="toggleTitle">
                    {{ cargo.title.length < 35 ? cargo.title : cargo.title.substring(0, 35) + "..." }} </span>
                        <span v-else>
                            {{ cargo.title }}
                        </span>
            </div>
        </div>
        <div class="additional-info-wrapper">
            <div class="additional-info-label" style="margin-left: 36px;">کرایه</div>
            <div class="additional-info-item" style="position: relative">
                <span class="fw-bolder fs-12" v-if="cargo.priceBased == 'توافقی'">توافقی</span>
                <span class="fw-bolder fs-12" v-else>{{ formatPrice(cargo.suggestedPrice) }} تومان</span>
            </div>
        </div>
        <div class="additional-info-wrapper">
            <div class="additional-info-label" style="margin-left: 32px;">ناوگان</div>
            <div class="additional-info-item">
                <span v-for="fleet in fleets" :key="fleet.id">
                    {{ fleet.title + ' ' }}
                </span>
            </div>
        </div>

        <div v-show="cargo.description != null" class="additional-info-wrapper">
            <div class="additional-info-label" style="margin-left: 14px;">توضیحات</div>
            <div v-if="cargo.description != null">
                <div class="additional-info-item" @click="handleDescription()">
                    <span v-if="toggleDescription">
                        {{ cargo.description.length < 30 ? cargo.description : cargo.description.substring(0, 30) + "..." }}
                     </span>
                    <span v-else>
                        {{ cargo.description }}
                    </span>
                        
                </div>
            </div>
            <div class="additional-info-item" v-else>
                -
            </div>
        </div>

        <hr>
        <!-- <div class="text-left">
            <div class="return-loads-text">
                <button type="button" class="btn btn-link load-back p-0" data-bs-toggle="offcanvas"
                    @click="getDetailLoad" :data-bs-target="'#cargoDetail' + loadId">
                    مشاهده جزئیات بار
                    <ion-icon role="img" class="md hydrated" style="font-size: 15px; padding-top: 6px;"
                        name="chevron-forward-outline"></ion-icon>
                </button>
            </div>
        </div> -->

        <div class="offcanvas offcanvas-bottom action-sheet" tabindex="-1" :id="'cargoDetail' + loadId">
            <div class="offcanvas-header">
                <h5 class="offcanvas-title">جزئیات بیشتر</h5>
            </div>
            <div class="offcanvas-body">
                <Optional :loadId="loadId" :optional="optional" :cargo="cargo" />
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
import Optional from '@/views/cargo/components/Optional.vue'

export default {
    props: ['cargo', 'owner', 'loading'],
    components: {
        Optional
    },
    data() {
        return {
            fleets: JSON.parse(this.cargo.fleets),
            toggleTitle: true,
            toggleDescription: true,
            optional: []
        };
    },
    methods: {
        formatPrice(value) {
            let val = (value / 1).toFixed(0).replace(".", ",");
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        },
        handleTitle() {
            this.toggleTitle = !this.toggleTitle;
        },
        handleDescription() {
            this.toggleDescription = !this.toggleDescription;
        },
        getDetailLoad() {
            localStorage.setItem("openDetailLoad", this.loadId);
            if (history.pushState) {
                var newurl = window.location.protocol +
                    "//" +
                    window.location.host +
                    window.location.pathname +
                    "?openDetailLoad=1";
                window.history.pushState({ path: newurl }, "", newurl);
            }
        },
    }
}
</script>
<style scoped>
.info-container {
    font-size: 12px;
    /* border-bottom: 1px solid #d9d9d9; */
    padding-bottom: 8px;
}

.load-back {
    font-size: 13px;
    font-weight: 300;
}

.additional-info-wrapper {
    display: flex;
    margin-top: 8px;
    padding-right: 5px;
}

.additional-info-item {
    justify-content: center;
    color: var(--Black, #000);
    font-weight: 500;
    font-size: 12px;
    text-align: right;
    flex: 1;
    padding-right: 16px;
    border-right: 1px solid #d9d9d9;
}

.additional-info-label {
    margin-left: 20px;
}

.ownerLabel {
    width: 67px;
    font-size: 11px;
    position: absolute;
    left: 0;
    top: 6px;
    text-align: center;
    border-radius: 0 9px;
    transform: rotate(311deg);
    background-color: #0099c9;
    color: white;
}
</style>